import { Checkbox } from "@mui/material";
import { classes } from "portal/theme/theme";
import { Dimensions } from "portal/utils/categoryCollection/image";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import React, { FC, MouseEvent } from "react";

const ICON_CLASS = "text-lg";

interface SelectThumbnailOverlayProps {
  thumbnailDimensions: Dimensions;
  selected: boolean;
  disabled?: boolean;
  onClick: (isSelected: boolean) => void;
}

export const SelectThumbnailOverlay: FC<SelectThumbnailOverlayProps> = ({
  selected,
  disabled = false,
  thumbnailDimensions,
  onClick,
}) => {
  const isSmall = thumbnailDimensions.width < 150;

  return (
    <div
      className={classes("absolute pointer-events-none", {
        "top-0.5 left-1": isSmall,
        "top-1 left-1.5": !isSmall,
      })}
    >
      <Checkbox
        disabled={disabled}
        size="small"
        disableRipple
        className={classes("p-0 pointer-events-auto", {
          "pointer-events-none text-gray-300 bg-gray-300/30": disabled,
          "text-white": !disabled && !selected,
          "bg-white text-blue-500 hover:text-blue-400": !disabled && selected,
        })}
        icon={<RadioButtonUncheckedIcon className={ICON_CLASS} />}
        checkedIcon={
          <CheckCircleIcon className={classes(ICON_CLASS, "text-blue-500")} />
        }
        checked={selected}
        onClick={(event: MouseEvent) => {
          event.stopPropagation();
          if (disabled) {
            return;
          }
          onClick(!selected);
        }}
      />
    </div>
  );
};
